import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow as MuiTableRow,
} from "@mui/material";

import { MUIStyled } from "../../../shared/MUIStyled";
import SABox from "../../../shared/SABox";
import SATypography from "../../../shared/SATypography";
import SATarget from "../../../shared/table-components/SATarget";

const TableContainerStyled = MUIStyled(TableContainer)({
  boxShadow: "none",
  maxHeight: 220,
  width: "100%",
  background: "#fff",
  "&.MuiPaper-root": {
    margin: 0,
  },
});
const TableCellHeadStyled = MUIStyled(TableCell)({
  fontWeight: 700,
  background: "#f9fafb",
  color: "#111827",
  borderBottom: "1px solid #eee",
  fontSize: 15,
  padding: 8,
});
const TableCellBodyStyled = MUIStyled(TableCell)({
  color: "#111827",
  fontWeight: 500,
  fontSize: 13,
  padding: 8,
});

const columns = [
  { key: "precious_item_name", label: "precious-item" },
  { key: "serial_number", label: "serial-number" },
  { key: "material_item_name", label: "material-item" },
  { key: "weight", label: "weight" },
];

export default function JewelerSerialNumberTable({ data, t }) {
  return (
    <SABox sx={{ backgroundColor: "#fff" }}>
      <TableContainerStyled
        component={Paper}
        sx={{
          overflowY: data.length > 4 ? "auto" : "unset",
          width: "100%",
        }}
      >
        <Table
          size="small"
          sx={{
            width: "100%",
            border: "1px solid #e5e7eb",
            boxShadow: "none",
            background: "#fff",
          }}
          stickyHeader
        >
          <TableHead>
            <MuiTableRow>
              {columns.map((col) => (
                <TableCellHeadStyled key={col.key}>
                  {t(col.label)}
                </TableCellHeadStyled>
              ))}
            </MuiTableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (
              <MuiTableRow>
                <TableCellBodyStyled
                  colSpan={columns.length + 1}
                  align="center"
                >
                  <SATypography sx={{ color: "#6B7280", py: 1 }}>
                    {t("no-data-found")}
                  </SATypography>
                </TableCellBodyStyled>
              </MuiTableRow>
            ) : (
              data.map((row, idx) => (
                <MuiTableRow key={idx}>
                  {columns.map((col) => {
                    let value = "-";
                    if (col.key === "precious_item_name") {
                      value =
                        row?.precious_item_unit?.precious_item_name || "-";
                    } else if (col.key === "serial_number") {
                      value = row?.precious_item_unit?.serial_number || "-";
                    } else if (col.key === "material_item_name") {
                      value = row?.precious_item_unit?.material_item || "-";
                    } else if (col.key === "weight") {
                      value = <SATarget value={row?.weight} /> || "-";
                    }
                    return (
                      <TableCellBodyStyled key={col.key}>
                        {value}
                      </TableCellBodyStyled>
                    );
                  })}
                </MuiTableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainerStyled>
    </SABox>
  );
}
